<div class="example-message">
  <ng-content></ng-content>
</div>
